import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { Form, InputGroup, Col, Row, Button, FloatingLabel } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';
import DBService from '../../service/DBService';
import ApiService from '../../service/ApiService';
import ScreenerSelect from '../screener/ScreenerSelect';
//import ATSShowDetails from './ATSShowDetails';
import '../../css/ATSListDisplay.css';
import { getCookie } from '../../service/Cookie';
import { convertDate } from '../../service/Util';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Filter" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "id",
        text: "Id",
        sort: 'True',
        hidden: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "symbol",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "name",
        text: "Name",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "currentPrice",
        text: "Current Price",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        editable: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                backgroundColor: '#f2f2f2'
            }
        }
    },
    {
        dataField: "profit",
        text: "Profit",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        editable: false,
        formatter: (cell, row) => {
            return (<>{parseFloat(cell).toFixed(2)}</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.profit > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
];


const columns = [
    {
        dataField: "id",
        text: "Id",
        sort: 'True',
        hidden: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "symbol",
        text: "Ticker",
        sort: 'True',
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "name",
        text: "Name",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "status",
        text: "Status",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "type",
        text: "Type",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "transactionType",
        text: "Transaction Type",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "transactionDate",
        text: "Date",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "currentPrice",
        text: "Current Price",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        editable: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                backgroundColor: '#f2f2f2'
            }
        }
    },
    // {
    //     dataField: "currentPercentage",
    //     text: "Current %",
    //     sort: 'True',
    //     headerStyle: { fontSize: '10px' },
    //     editable: false
    // },
    {
        dataField: "quantity",
        text: "Quantity",
        sort: 'True',
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "buy",
        text: "Buy",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        // hidden: false,
        // editable: false
    },
    {
        dataField: "sell",
        text: "Sell",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        // hidden: false,
        // editable: false
    },
    {
        dataField: "profit",
        text: "Profit",
        sort: 'True',
        headerStyle: { fontSize: '10px' },
        hidden: false,
        editable: false,
        formatter: (cell, row) => {
            return (<>{parseFloat(cell).toFixed(2)}</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.profit > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
];

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

// const selectRow = {
//     mode: 'radio',
//     clickToSelect: true,
//     clickToEdit: true  // Click to edit cell also
// };

class PortfolioAverageListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbol: this.props.symbol,
            atsWeeklyList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: '',
            weeklyOptions: [],
            selectedStock: {
                symbol: '',
                name: '',
                avgBuyPrice: '',
                avgSellPrice: ''
            },
            prePostMarket: '',
            prePostMarketWorking: false,
            saveLabel: 'Save'
        };
        console.log('PortfolioAverageListDisplay props', this.props, this.state.symbol);
    }

    componentDidMount() {
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 15); //15 mins
        this.getData();
    }

    getUserId() {
        let userId = '';
        let cookieValue = getCookie();
        if (cookieValue !== undefined && cookieValue.userId !== undefined) {
            console.log('Setting userId', cookieValue.userId);
            userId = cookieValue.userId;
        }
        return userId;
    }

    checkPrePostStockUp(){
        ApiService.getPrePostStockToday('AAPL', '1min')
        .then(resultApi => {
            console.log('pre post market price', resultApi);
            if (resultApi !== undefined && resultApi.results !== undefined && resultApi.results.length > 0) {
                let { amPm, amPmStr } = this.getAmPm();
                this.setState({prePostMarketWorking: true, prePostMarket: amPmStr});
            } else {
                this.setState({prePostMarketWorking: false, prePostMarket: ''});
            }
        })
        .catch(error => {
            console.log('error ', error);
        });        
    }

    async getAllPrePostStocksPrice(tmpOptions, result) {
        let allSymbols = [];
        for (var i = 0; i < result.length; i++) {
            let obj = allSymbols.find(o => o.symbol === result[i].symbol);
            if (obj === undefined) {
                console.log('checkprepost', this.state.prePostMarketWorking);
                if (this.state.prePostMarketWorking && result[i].type.toLowerCase() === 'stock') {
                    await ApiService.getPrePostStockToday(result[i].symbol, '1min')
                        .then(resultApi => {
                            console.log('pre post market price', resultApi);
                            if (resultApi !== undefined && resultApi.results !== undefined && resultApi.results.length > 0) {
                                let resData = resultApi.results;
                                let close = resData[resData.length - 1].c;
                                result[i].currentPrice = close;
                                if (result[i].sell !== '' && result[i].sell > 0) {
                                    result[i].profit = result[i].quantity * (result[i].sell - result[i].buy);
                                } else {
                                    result[i].profit = result[i].quantity * (result[i].currentPrice - result[i].buy);
                                }
                                console.log('last close', close, result[i - 1], i);
                                allSymbols.push({ symbol: result[i].symbol, price: close });
                            }
                        })
                        .catch(error => {
                            console.log('error ', error);
                        });
                } else { //Get it for all other futures, crypto etc
                    await ApiService.getQuotes(result[i].symbol)
                        .then(resultApi => {
                            console.log('current market price', resultApi);
                            if (resultApi !== undefined && resultApi.length !== undefined && resultApi.length > 0) {
                                result[i].currentPrice = resultApi[0].price;
                                result[i].profit = result[i].quantity * (result[i].currentPrice - result[i].buy);
                                console.log('last close', result[i], i);
                                allSymbols.push({ symbol: result[i].symbol, price: result[i].currentPrice });
                            }
                        });
                }
            } else {
                console.log('pre post market price getting from cache', obj.symbol, obj.price);
                result[i].currentPrice = obj.price;
                if (result[i].sell !== '' && result[i].sell > 0) {
                    result[i].profit = result[i].quantity * (result[i].sell - result[i].buy);
                } else {
                    result[i].profit = result[i].quantity * (result[i].currentPrice - result[i].buy);
                }
            }
        }
        result.sort(this.custom_sort);
        this.setState({ weeklyOptions: tmpOptions, atsWeeklyList: result, reload: true });
    }

    async getAllMarketStocksPrice(tmpOptions, result) {
        let allSymbols = [];
        for (var i = 0; i < result.length; i++) {
            let obj = allSymbols.find(o => o.symbol === result[i].symbol);
            if (obj === undefined) {
                await ApiService.getQuotes(result[i].symbol)
                    .then(resultApi => {
                        console.log('current market price', resultApi);
                        if (resultApi !== undefined && resultApi.length !== undefined && resultApi.length > 0) {
                            result[i].currentPrice = resultApi[0].price;
                            result[i].profit = result[i].quantity * (result[i].currentPrice - result[i].buy);
                            console.log('last close', result[i], i);
                            allSymbols.push({ symbol: result[i].symbol, price: result[i].currentPrice });
                        }
                    });
            } else {
                console.log('current market price getting from cache', obj.symbol, obj.price);
                result[i].currentPrice = obj.price;
                if (result[i].sell !== '' && result[i].sell > 0) {
                    result[i].profit = result[i].quantity * (result[i].sell - result[i].buy);
                } else {
                    result[i].profit = result[i].quantity * (result[i].currentPrice - result[i].buy);
                }
            }
        }
        result.sort(this.custom_sort);
        this.setState({ weeklyOptions: tmpOptions, atsWeeklyList: result, reload: true });
    }

    custom_sort(a, b) {
        if (a.profit > b.profit) { return -1; }
        if (a.profit < b.profit) { return 1; }
        return 0;
    }


    getData() {
        let body = {
            userId: this.getUserId()
        }
        DBService.userPortfolioDistincName(body)
            .then(result => {
                this.checkPrePostStockUp();
                console.log('userPortfolioDistincNames', result);
                if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                    result = result.data;
                    let tmpOptions = [];
                    for (var i = 0; i < result.length; i++) {
                        if (i === 0) {
                            tmpOptions.push({ "labelKey": { criteria: 'weekly', value: result[i].name }, "value": result[i].name, "isSelected": true });
                        } else {
                            tmpOptions.push({ "labelKey": { criteria: 'weekly', value: result[i].name }, "value": result[i].name });
                        }
                    }
                    this.setState({ weeklyOptions: tmpOptions, reload: true });
                    console.log('weeklyOptions', tmpOptions, tmpOptions[0].value);
                    let body1 = {
                        userId: this.getUserId(),
                        //name: tmpOptions[0].value,
                        status: 'Open'
                    }
                    DBService.userPortfolioAverage(body1)
                        .then(result => {
                            console.log(' getAtsWeeklyTotal', result);
                            if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                                result = result.data;
                                let { amPm, amPmStr } = this.getAmPm();
                                console.log('ampm', amPm, amPmStr);
                                if (amPm !== '') {
                                    //this.setState({ prePostMarket: amPmStr });
                                    this.getAllPrePostStocksPrice(tmpOptions, result);
                                } else {
                                    this.getAllMarketStocksPrice(tmpOptions, result);
                                }
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    getAmPm() {
        let now = new Date();
        let hour = now.getHours();
        let minutes = now.getMinutes();
        let amPm = '';
        let amPmStr = '';
        console.log('now, hour, min', hour, minutes);

        if (hour >= 16) {
            amPm = 'ah';
            amPmStr = 'After Hours';
        } else if (hour <= 9) {
            if (hour === 9 && minutes >= 30) {
                amPm = '';
            } else {
                amPm = 'pm';
                amPmStr = 'Pre Market';
            }
        } else if ((hour >= 9 && minutes >= 30) && (hour <= 15 && minutes >= 59)) {
            amPm = '';
        }

        console.log('amPm', amPm, amPmStr);
        return { amPm, amPmStr }
    }


    componentWillUnmount() {
        clearInterval(this.interval);
    }

    selectUpdateObj(selectedOptions) {
        let tmpObj = {
            selectedKey: [
                JSON.parse(selectedOptions.target.value)
            ],
            selectedValue: []
        }
        return tmpObj;
    }

    // handleWeeklyChange = (selectedOptions) => {
    //     this.selectedWeekly = this.selectUpdateObj(selectedOptions);
    //     console.log('ats Screen Criteria -selected weekly', this.selectedWeekly, selectedOptions);
    //     const key = this.selectedWeekly.selectedKey[0];
    //     let body = {
    //         userId: this.getUserId(),
    //         name: key.value
    //     }
    //     DBService.userPortfolio(body)
    //         .then(result => {
    //             console.log('ats getAtsWeeklyTotal', result);
    //             if (result !== undefined && result.data !== undefined && result.data.length > 0) {
    //                 result = result.data;
    //                 this.setState({ atsWeeklyList: result });
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });

    // }

    addNewRow = () => {
        let tmp = {
            id: Math.random(),
            symbol: '',
            name: '',
            status: 'Open',
            type: 'Stock',
            transactionType: "Long",
            transactionDate: convertDate(new Date()),//"2022-02-11",
            currentPrice: '',
            quantity: 1,
            buy: '',
            sell: '',
            profit: 0,
            userId: this.getUserId(),
            dbOption: 'insert'
        };
        console.log('addnew', tmp);
        this.setState({ atsWeeklyList: [tmp, ...this.state.atsWeeklyList] });
    }

    // addNewProfile = () => {
    //     console.log('New Profile');
    // }


    save = () => {
        this.setState({saveLabel: 'Saving...'});
        console.log('save', this.state.atsWeeklyList);
        for (var i = 0; i < this.state.atsWeeklyList.length; i++) {
            if (this.state.atsWeeklyList[i].dbOption === 'update') {
                DBService.userPortfolioAverageUpdate(this.state.atsWeeklyList[i]);
            } else if (this.state.atsWeeklyList[i].dbOption === 'insert') {
                DBService.userPortfolioAverageCreate(this.state.atsWeeklyList[i]);
            }
        }
        this.setState({saveLabel: 'Save'});
        this.getData();
    }

    refresh = () => {
        this.getData();
    }

    selectRow = (row, isSelect, rowIndex) => {
        console.log('selected row', row);
        let { avgBuyPrice, avgSellPrice } = this.calculateAverage(row);
        this.setState({
            selectedStock: {
                symbol: row.symbol,
                name: row.name,
                avgBuyPrice: avgBuyPrice.toFixed(2),
                avgSellPrice: avgSellPrice.toFixed(2)
            }
        })
    }

    calculateAverage = (row) => {
        let totalBuyQty = 0, totalSellQty = 0, totalBuyPrice = 0, totalSellPrice = 0;
        for (var i = 0; i < this.state.atsWeeklyList.length; i++) {
            let quantity = parseInt(this.state.atsWeeklyList[i].quantity);
            if (row.symbol === this.state.atsWeeklyList[i].symbol && row.name === this.state.atsWeeklyList[i].name) {
                if (this.state.atsWeeklyList[i].buy !== undefined && this.state.atsWeeklyList[i].buy > 0) {
                    console.log('Matching row', row.symbol, row.name)
                    totalBuyPrice += quantity * this.state.atsWeeklyList[i].buy;
                    totalBuyQty += quantity;
                }

                if (this.state.atsWeeklyList[i].sell !== undefined && this.state.atsWeeklyList[i].sell > 0) {
                    totalSellQty += quantity;
                    totalSellPrice += quantity * this.state.atsWeeklyList[i].sell;
                }
            }
        }
        let avgBuyPrice = (totalBuyPrice / totalBuyQty) || 0;
        let avgSellPrice = (totalSellPrice / totalSellQty) || 0;
        console.log('total avg', totalBuyQty, totalBuyPrice)
        return { avgBuyPrice, avgSellPrice };
    }


    render() {
        if (this.state.reload) {
            console.log('PortfolioAverageListDisplay Reloading...');
            this.setState({ reload: false });
            return (<div>Loading...</div>);
        }

        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="id"
                        data={this.state.atsWeeklyList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>  <Row>
                                    {/* <Col xs="6" md="3" lg="3" xl="3">
                                        <ScreenerSelect options={this.state.weeklyOptions} onChange={this.handleWeeklyChange} label={'Name'} />
                                    </Col>

                                    <Col xs="6" md="4" lg="4" xl="5">
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="New Portfolio Name"
                                            key="name"
                                            className="mb-3"
                                        >
                                            <Form.Control type="name" placeholder="Portfolio Name" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
                                        </FloatingLabel>

                                    </Col>
                                    <Col xs="3" md="2" lg="2" xl="1">
                                        <Button variant="primary" onClick={this.addNewProfile}>Add New Portfolio</Button>
                                    </Col> */}
                                    <Col xs="12" md="12" lg="7" xl="7">
                                        {(this.state.prePostMarket !== '') ? <><b>({this.state.prePostMarket})</b></> : <></>}
                                        Ticker: <b>{this.state.selectedStock.symbol}</b>,
                                        Name: <b>{this.state.selectedStock.name}</b>,
                                        Average Buy Price: <b>${this.state.selectedStock.avgBuyPrice}</b>,
                                        Average Sell Price: <b>${this.state.selectedStock.avgSellPrice}</b>

                                    </Col>
                                    <Col >
                                        <Button variant="primary" onClick={this.addNewRow}>Add New Row</Button>
                                    </Col>
                                    <Col >
                                        <Button variant="success" onClick={this.save}>{this.state.saveLabel}</Button>
                                    </Col>
                                    {/*<Col >
                                        <Button variant="link" onClick={this.refresh}>Refresh</Button>
                                    </Col> */}
                                </Row>
                                    <Row>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        keyField="id"
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        //expandRow={expandRow}
                                        //selectRow={ selectRow }
                                        selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            clickToEdit: true,
                                            onSelect: this.selectRow
                                        }}
                                        pagination={paginationFactory(options)}
                                        cellEdit={cellEditFactory({
                                            mode: 'click',
                                            blurToSave: true,
                                            autoSelectText: true,
                                            afterSaveCell: (oldValue, newValue, row, column) => {
                                                console.log('cell edited', oldValue, newValue, row, column);
                                                //this.state.selectedStock.symbol = row.symbol.toUpperCase();
                                                if (column.dataField === 'sell' || column.dataField === 'buy' || column.dataField === 'quantity') {
                                                    row.profit = row.quantity * (row.sell - row.buy);
                                                }
                                                if (column.dataField === 'symbol') {
                                                    row.symbol = row.symbol.toUpperCase();
                                                }
                                                if (row.dbOption !== undefined && row.dbOption === 'insert') {
                                                    row.dbOption = 'insert'
                                                } else {
                                                    row.dbOption = 'update';
                                                }
                                                console.log('result', this.state.atsWeeklyList);
                                            }
                                        })}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="id"
                        data={this.state.atsWeeklyList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>  <Row>
                                    {/* <Col xs="6" md="3" lg="3" xl="3">
                                        <ScreenerSelect options={this.state.weeklyOptions} onChange={this.handleWeeklyChange} label={'Name'} />
                                    </Col>

                                    <Col xs="6" md="3" lg="3" xl="3">
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="New Portfolio Name"
                                            key="name"
                                            className="mb-3"
                                        >
                                            <Form.Control type="name" placeholder="Portfolio Name" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} />
                                        </FloatingLabel>

                                    </Col>
                                    <Col >
                                        <Button variant="primary" onClick={this.addNewProfile}>Add New Portfolio</Button>
                                    </Col> */}
                                    <Col xs="12" md="12" lg="7" xl="7">
                                        {(this.state.prePostMarket !== '') ? <><b>({this.state.prePostMarket})</b></> : <></>}
                                        Ticker: <b>{this.state.selectedStock.symbol}</b>,
                                        Name: <b>{this.state.selectedStock.name}</b>,
                                        Average Buy Price: <b>${this.state.selectedStock.avgBuyPrice}</b>,
                                        Average Sell Price: <b>${this.state.selectedStock.avgSellPrice}</b>

                                    </Col>
                                    <Col >
                                        <Button variant="primary" onClick={this.addNewRow}>Add New Row</Button>
                                    </Col>
                                    <Col >
                                        <Button variant="success" onClick={this.save}>{this.state.saveLabel}</Button>
                                    </Col>
                                    {/*<Col >
                                        <Button variant="link" onClick={this.refresh}>Refresh</Button>
                                    </Col>*/}

                                </Row>
                                    <Row>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    {/* <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        //expandRow={expandRow}
                                        //selectRow={ selectRow }
                                        pagination={paginationFactory(options)}
                                    /> */}

                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        keyField="id"
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        //expandRow={expandRow}
                                        //selectRow={ selectRow }
                                        selectRow={{
                                            mode: 'radio',
                                            clickToSelect: true,
                                            clickToEdit: true,
                                            onSelect: this.selectRow
                                        }}
                                        pagination={paginationFactory(options)}
                                        cellEdit={cellEditFactory({
                                            mode: 'click',
                                            blurToSave: true,
                                            autoSelectText: true,
                                            afterSaveCell: (oldValue, newValue, row, column) => {
                                                console.log('cell edited', oldValue, newValue, row, column);
                                                //this.state.selectedStock.symbol = row.symbol.toUpperCase();
                                                if (column.dataField === 'sell' || column.dataField === 'buy' || column.dataField === 'quantity') {
                                                    row.profit = row.quantity * (row.sell - row.buy);
                                                }
                                                if (column.dataField === 'symbol') {
                                                    row.symbol = row.symbol.toUpperCase();
                                                }
                                                if (row.dbOption !== undefined && row.dbOption === 'insert') {
                                                    row.dbOption = 'insert'
                                                } else {
                                                    row.dbOption = 'update';
                                                }
                                                console.log('result', this.state.atsWeeklyList);
                                            }
                                        })}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default PortfolioAverageListDisplay;
